import React from 'react';
import { AlertCircle } from 'lucide-react';

export const WarningMessage = () => {
  return (
    <div className="flex items-start gap-3 bg-yellow-50 text-yellow-700 p-4 rounded-lg">
      <AlertCircle className="shrink-0 mt-0.5" size={20} />
      <div className="text-sm">
        <p className="font-medium">تنبيه مهم</p>
        <p>تأكد من أن الملف يتبع النموذج المطلوب. يمكنك تحميل نموذج مثالي من زر "مثال للرفع".</p>
      </div>
    </div>
  );
};